import React, { Component } from 'react'
import StyleSheet from 'styles'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Chip from '@material-ui/core/Chip'
import { connect } from 'react-redux'
import { SessionStatus } from '../../constants'
import { TokenActions } from 'actionsets'
import * as Containers from 'containers'
import { withRouter } from 'react-router-dom'
import { Routes, Nav } from '.'
import {ConditionalRender, Footer, Link} from 'components'
import AppBar from '@material-ui/core/AppBar'
import { intToRGB, hashCode } from 'utils'
import { baseTheme } from 'styles'
import KycBar from 'containers/user/KycBar'
import { throttle } from 'utils'

import JssProvider from 'react-jss/lib/JssProvider'
import { create } from 'jss'
import { createGenerateClassName, jssPreset } from '@material-ui/core/styles'

const generateClassName = createGenerateClassName()
const jss = create(jssPreset())
// We define a custom insertion point that JSS will look for injecting the styles in the DOM.
jss.options.insertionPoint = 'mui-jss-insertion-point'

export class App extends Component{

  static activityEventTypes = ['mousemove', 'click', 'keydown', 'resize']

  constructor(props){
    super(props)
    TokenActions.bindActions(this, 'token')
    this.actions.token.verify(true)
  }

  componentDidCatch(error, {componentStack}){
    console.error('An uncaught error occurred while rendering. Redirecting to error status page')
    console.error(componentStack)
    if(process.env.NODE_ENV !== 'development')
      this.props.history.replace('/error_occurred')
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.loginState === SessionStatus.UNAUTHENTICATED && this.props.loginState !== prevProps.loginState)
      this.actions.token.globalResetState()
  }

  renderRoutes = () => {
    switch(this.props.loginState){
    case SessionStatus.UNKNOWN:         { return <Routes.Unknown/> }
    case SessionStatus.AUTHENTICATED:   { return <Routes.Authenticated/> }
    case SessionStatus.UNAUTHENTICATED: { return <Routes.Unauthenticated/> }
    default: { return false }
    }
  }

  renderNav = () => {
    switch(this.props.loginState){
    case SessionStatus.UNKNOWN:         { return <Nav.Unknown/> }
    case SessionStatus.AUTHENTICATED:   { return <Nav.Authenticated currentPath={this.props.location.pathname}/> }
    case SessionStatus.UNAUTHENTICATED: { return <Nav.Unauthenticated/> }
    default: { return false }
    }
  }

  get homeLink() {
    return this.props.loginState === SessionStatus.AUTHENTICATED ? '/' : (process.env.REACT_APP_PUBLIC_SITE || '/')
  }

  registerActivity = throttle(() => {
    this.actions.token.registerActivity()
  })

  monitorActivity = container => {
    if(this.container){
      App.activityEventTypes.forEach(type => this.container.removeEventListener(type, this.registerActivity))
    }
    this.container = container
    if(this.container){
      App.activityEventTypes.forEach(type => this.container.addEventListener(type, this.registerActivity))
    }
  }

  render = () =>
  <JssProvider jss={jss} generateClassName={generateClassName}>
    <div className={styles.root}>
      <div className={styles.appBarContainer}>
        <AppBar className={styles.appBar} position="static">
          <Containers.Snackbar/>
          <KycBar/>
          <Toolbar className={styles.toolbar}>
            <Typography component='div' type="h6" color="inherit" className={styles.heading}>
              <Link style={{color: 'inherit', textDecoration: 'none'}} className='homeLink' to={this.homeLink}>
                <img className={styles.logo} src={`${process.env.REACT_APP_RESOURCE_PATH}/logo-neg.svg`} alt={process.env.REACT_APP_NAME} style={{width: 185, verticalAlign: 'middle'}} />
                <img className={styles.altLogo} src={`${process.env.REACT_APP_RESOURCE_PATH}/logo-pos.svg`} alt={process.env.REACT_APP_NAME} style={{width: 185, verticalAlign: 'middle'}} />
              </Link>
              <ConditionalRender className={styles.statusChip} requires={process.env.REACT_APP_ENVIRONMENT !== 'production'} component={Chip} label={process.env.REACT_APP_ENVIRONMENT}/>
            </Typography>
            {this.renderNav()}
          </Toolbar>
        </AppBar>
        <Containers.GlobalLoaderOverlay/>
      </div>
      <div className={styles.scrollContainer} id="scrollContainer" ref={this.monitorActivity}>
        {this.renderRoutes()}
        <Footer/>
      </div>
    </div>
  </JssProvider>
}

const styles = StyleSheet({
  root: {
    width:         '100%',
    flex:          1,
    display:       'flex',
    flexDirection: 'column',
    height:        'fit-content',
    minHeight:     '100vh',

    '@media print': {
      '& button': {
        display: 'none'
      }
    }
  },
  appBar: {
    top: 'auto',
    boxSizing: 'border-box',
    '@media print': {
      backgroundColor: 'transparent',
    },
  },
  appBarContainer: {
    zIndex: 1200,
    position: 'sticky',
    top: 0,
    overflow: 'visible',
    '@media print': {
      position: 'static',
    },
  },
  scrollContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '100vw'
  },
  statusChip: {
    display: 'inline-flex',
    margin: '0 10px',
    backgroundColor: `#${intToRGB(hashCode(process.env.REACT_APP_ENVIRONMENT))}`
  },
  toolbar: {
    boxSizing: 'border-box',
    position: 'relative',
    paddingRight: 0,
    paddingLeft: 0,
    height: 'inherit',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  heading: {
    flex: 1,
    maxWidth: baseTheme.siteStyleguide.maxWidth - 650,
    boxSizing: 'border-box',
    paddingLeft: 40,
    paddingTop: 20,
    paddingBottom: 20,
    alignSelf: 'center',
    '@media(max-width: 600px)': {
      height: 90,
      paddingLeft: 25,
    },
    '@media(max-width: 960px)': {
      maxWidth: 'none'
    },
    '@media print': {
      height: 70,
      padding: [10, 0],
    }
  },
  logo: {
    '@media print': {
      display: 'none'
    }
  },
  altLogo: {
    '@media screen': {
      display: 'none'
    }
  }
})


export default withRouter(connect(({tokens}) => tokens)(App))